import { LocaleEnum } from '@systemeio/ui'
import useUser from 'shared/hooks/use-user'
import { HelpScout } from './help-scout'
import { BoldDesk } from './bolddesk'
import { isSioHost, isClient } from '@systemeio/util'
import { ChatKit } from './chat-kit'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { GrowthbookFlagsEnum } from 'growthbook/types'

const newBotLocales: LocaleEnum[] = []

export function HelpBots() {
  const { user, isCustomer } = useUser()
  const isAIOn = useFeatureIsOn(GrowthbookFlagsEnum['AI-assistant'])
  if (!user) return null

  const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'development'
  if (isDev) return null

  const isSio = isClient() ? isSioHost(window.location.host) : false
  if (!isSio) return null

  const useNewBot = newBotLocales.includes(user.dashboardLocale)
  const shouldShowChatKit = isAIOn && isCustomer

  return (
    <>
      {shouldShowChatKit ? (
        <ChatKit />
      ) : (
        <>
          <HelpScout shouldRender={!useNewBot} locale={user.dashboardLocale} />
          <BoldDesk shouldRender={useNewBot} locale={user.dashboardLocale} />
        </>
      )}
    </>
  )
}
